"use client";

import { useRef, useState } from "react";

export function useSubmitLock() {
  const submitLockRef = useRef(false);
  const [submitting, setSubmitting] = useState(false);

  const tryStart = () => {
    if (submitLockRef.current) {
      return false;
    }

    submitLockRef.current = true;
    setSubmitting(true);
    return true;
  };

  const finish = () => {
    submitLockRef.current = false;
    setSubmitting(false);
  };

  return {
    submitting,
    tryStart,
    finish,
  };
}
